import SimpleBar from 'simplebar';

function initReviews() {
    const reviewsSlider = document.getElementById('reviewsSlider');
    
    if (!reviewsSlider) {
        return;
    }
    
    const slidesContainer = reviewsSlider.querySelector('.reviews__slides');
    if (!slidesContainer) {
        return;
    }
    
    const slides = Array.from(slidesContainer.querySelectorAll('.reviews__slide'));
    
    if (slides.length === 0) {
        return;
    }
    
    const leftContainer = reviewsSlider.closest('.reviews__left');
    const pagination = leftContainer ? leftContainer.querySelector('.reviews__pagination') : null;
    
    if (!pagination) {
        return;
    }
    
    let activeSlideIndex = 0;
    const visibleCount = 3;
    let isTransitioning = false;
    
    const isMobile = () => {
        return window.innerWidth <= 768;
    };
    
    const getVisibleSlides = (activeIndex) => {
        if (isMobile()) {
            return {
                active: activeIndex
            };
        }
        
        if (activeIndex === 0) {
            return {
                prev: null,
                active: activeIndex,
                next: activeIndex + 1 < slides.length ? activeIndex + 1 : null,
                nextNext: activeIndex + 2 < slides.length ? activeIndex + 2 : null
            };
        } else if (activeIndex === slides.length - 1) {
            return {
                prev: activeIndex - 2 >= 0 ? activeIndex - 2 : null,
                prev2: activeIndex - 1 >= 0 ? activeIndex - 1 : null,
                active: activeIndex,
                next: null
            };
        } else {
            return {
                prev: activeIndex - 1,
                active: activeIndex,
                next: activeIndex + 1
            };
        }
    };
    
    const createNavigation = () => {
        pagination.innerHTML = '';
        
        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'reviews__nav-btn reviews__nav-btn--prev';
        prevBtn.setAttribute('aria-label', 'Попередній слайд');
        prevBtn.innerHTML = `
            <svg class="icon icon-arrow" aria-hidden="true">
                <use href="#arrow"></use>
            </svg>
        `;
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (activeSlideIndex > 0 && !isTransitioning) {
                goToSlide(activeSlideIndex - 1);
            }
        });
        pagination.appendChild(prevBtn);
        
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'reviews__nav-btn reviews__nav-btn--next';
        nextBtn.setAttribute('aria-label', 'Наступний слайд');
        nextBtn.innerHTML = `
            <svg class="icon icon-arrow" aria-hidden="true">
                <use href="#arrow"></use>
            </svg>
        `;
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (activeSlideIndex < slides.length - 1 && !isTransitioning) {
                goToSlide(activeSlideIndex + 1);
            }
        });
        pagination.appendChild(nextBtn);
        
        return { prevBtn, nextBtn };
    };
    
    const initSimpleBarForAllSlides = () => {
        slides.forEach((slide) => {
            const textElement = slide.querySelector('.review-card__text');
            if (!textElement) {
                return;
            }
            
            const existingInstance = SimpleBar.instances.get(textElement);
            if (existingInstance) {
                return;
            }
            
            new SimpleBar(textElement, {
                autoHide: false,
                forceVisible: 'y',
                scrollbarMinSize: 50
            });
        });
    };
    
    const updateSimpleBarForSlide = (slide, isActive) => {
        const textElement = slide.querySelector('.review-card__text');
        if (!textElement) {
            return;
        }
        
        const instance = SimpleBar.instances.get(textElement);
        if (!instance) {
            return;
        }
        
        if (isActive) {
            textElement.classList.remove('reviews__text--scrollable');
            textElement.style.overflow = 'hidden';
            
            const enableScroll = () => {
                requestAnimationFrame(() => {
                    textElement.classList.add('reviews__text--scrollable');
                    textElement.style.overflow = '';
                    
                    requestAnimationFrame(() => {
                        instance.recalculate();
                        const scrollElement = instance.getScrollElement();
                        if (scrollElement) {
                            scrollElement.scrollTop = 0;
                        }
                    });
                });
            };
            
            let transitionEnded = false;
            const transitionDuration = 500;
            
            const handleTransitionEnd = (e) => {
                if (e.target === textElement && (e.propertyName === 'max-height' || e.propertyName === 'margin-top' || e.propertyName === 'opacity')) {
                    if (!transitionEnded) {
                        transitionEnded = true;
                        textElement.removeEventListener('transitionend', handleTransitionEnd);
                        enableScroll();
                    }
                }
            };
            
            textElement.addEventListener('transitionend', handleTransitionEnd);
            
            setTimeout(() => {
                if (!transitionEnded) {
                    transitionEnded = true;
                    textElement.removeEventListener('transitionend', handleTransitionEnd);
                    enableScroll();
                }
            }, transitionDuration);
        } else {
            textElement.classList.remove('reviews__text--scrollable');
            textElement.style.overflow = 'hidden';
        }
    };
    
    const updateSlider = () => {
        const visible = getVisibleSlides(activeSlideIndex);
        const mobile = isMobile();
        
        slides.forEach((slide, index) => {
            const textElement = slide.querySelector('.review-card__text');
            if (textElement) {
                textElement.classList.remove('reviews__text--scrollable');
                textElement.style.overflow = 'hidden';
            }
            
            slide.classList.remove('reviews__slide--active');
            slide.classList.remove('reviews__slide--visible');
            slide.classList.remove('reviews__slide--prev');
            slide.classList.remove('reviews__slide--next');
            
            slide.style.order = '';
            slide.style.display = '';
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.position = '';
            
            let order = 0;
            let shouldShow = false;
            
            if (mobile) {
                if (index === visible.active) {
                    slide.classList.add('reviews__slide--visible');
                    slide.classList.add('reviews__slide--active');
                    order = 1;
                    shouldShow = true;
                    updateSimpleBarForSlide(slide, true);
                } else {
                    updateSimpleBarForSlide(slide, false);
                }
            } else {
                if (activeSlideIndex === 0) {
                    if (index === 0) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--active');
                        order = 1;
                        shouldShow = true;
                    } else if (visible.next !== null && index === visible.next) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--next');
                        order = 2;
                        shouldShow = true;
                    } else if (visible.nextNext !== null && index === visible.nextNext) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--next');
                        order = 3;
                        shouldShow = true;
                    }
                } else if (activeSlideIndex === slides.length - 1) {
                    if (visible.prev !== null && index === visible.prev) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--prev');
                        order = 1;
                        shouldShow = true;
                    } else if (visible.prev2 !== null && index === visible.prev2) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--prev');
                        order = 2;
                        shouldShow = true;
                    } else if (index === visible.active) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--active');
                        order = 3;
                        shouldShow = true;
                    }
                } else {
                    if (visible.prev !== null && index === visible.prev) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--prev');
                        order = 1;
                        shouldShow = true;
                    }
                    
                    if (index === visible.active) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--active');
                        order = 2;
                        shouldShow = true;
                    }
                    
                    if (visible.next !== null && index === visible.next) {
                        slide.classList.add('reviews__slide--visible');
                        slide.classList.add('reviews__slide--next');
                        order = 3;
                        shouldShow = true;
                    }
                }
                
                if (shouldShow) {
                    const isActive = index === visible.active;
                    updateSimpleBarForSlide(slide, isActive);
                } else {
                    updateSimpleBarForSlide(slide, false);
                }
            }
            
            if (shouldShow) {
                slide.style.order = order;
            }
        });
        
        const prevBtn = pagination.querySelector('.reviews__nav-btn--prev');
        const nextBtn = pagination.querySelector('.reviews__nav-btn--next');
        
        if (prevBtn) {
            prevBtn.disabled = activeSlideIndex === 0;
            prevBtn.classList.toggle('reviews__nav-btn--disabled', activeSlideIndex === 0);
        }
        if (nextBtn) {
            nextBtn.disabled = activeSlideIndex === slides.length - 1;
            nextBtn.classList.toggle('reviews__nav-btn--disabled', activeSlideIndex === slides.length - 1);
        }
    };
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
        slides.forEach(slide => {
            const textElement = slide.querySelector('.review-card__text');
            if (textElement) {
                textElement.classList.remove('reviews__text--scrollable');
                textElement.style.overflow = 'hidden';
            }
            slide.style.order = '';
            slide.style.display = '';
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.position = '';
        });
        
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            slides.forEach(slide => {
                const textElement = slide.querySelector('.review-card__text');
                if (textElement) {
                    const instance = SimpleBar.instances.get(textElement);
                    if (instance) {
                        instance.recalculate();
                    }
                }
            });
            updateSlider();
        }, 150);
    });
    
    initSimpleBarForAllSlides();
    
    const goToSlide = (index) => {
        if (isTransitioning) {
            return;
        }
        
        if (index >= 0 && index < slides.length && index !== activeSlideIndex) {
            isTransitioning = true;
            activeSlideIndex = index;
            updateSlider();
            
            setTimeout(() => {
                isTransitioning = false;
            }, 500);
        }
    };
    
    slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
            if (e.target.closest('.reviews__nav-btn')) {
                return;
            }
            if (index !== activeSlideIndex) {
                goToSlide(index);
            }
        });
    });
    
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let swipeDirection = null;
    let touchStartTime = 0;
    
    const handleTouchStart = (e) => {
        if (!isMobile()) {
            return;
        }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        swipeDirection = null;
    };
    
    const handleTouchMove = (e) => {
        if (!isMobile()) {
            return;
        }
        
        if (swipeDirection === null) {
            const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
            const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
            
            if (deltaX > 10 || deltaY > 10) {
                if (deltaX > deltaY) {
                    swipeDirection = 'horizontal';
                } else {
                    swipeDirection = 'vertical';
                }
            }
        }
    };
    
    const handleTouchEnd = (e) => {
        if (!isMobile()) {
            return;
        }
        
        touchEndX = e.changedTouches[0].clientX;
        touchEndY = e.changedTouches[0].clientY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = Math.abs(touchEndY - touchStartY);
        const absDeltaX = Math.abs(deltaX);
        const minSwipeDistance = 50;
        const maxSwipeTime = 300;
        const swipeTime = Date.now() - touchStartTime;
        
        if (swipeDirection === 'horizontal' && 
            absDeltaX > minSwipeDistance && 
            absDeltaX > deltaY &&
            swipeTime < maxSwipeTime) {
            if (deltaX > 0 && activeSlideIndex > 0) {
                goToSlide(activeSlideIndex - 1);
            } else if (deltaX < 0 && activeSlideIndex < slides.length - 1) {
                goToSlide(activeSlideIndex + 1);
            }
        }
        
        swipeDirection = null;
    };
    
    if (reviewsSlider) {
        reviewsSlider.addEventListener('touchstart', handleTouchStart, { passive: true });
        reviewsSlider.addEventListener('touchmove', handleTouchMove, { passive: true });
        reviewsSlider.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
    
    const navButtons = createNavigation();
    updateSlider();
}

export default initReviews;

